export const Logo = ({ dark = false }) => (
  <div className="flex items-center gap-3" data-testid="brand-logo">
    <div className="flex h-11 items-center justify-center overflow-hidden rounded-xl bg-white px-2.5 py-1.5 shadow-sm ring-1 ring-[#0F1E19]/10">
      <img src="/logo-mark.png" alt="Verma Med Associates logo" className="h-full w-auto object-contain" />
    </div>
    <div className="leading-none">
      <p className={`font-display text-lg font-bold tracking-tight ${dark ? "text-[#F5F7F6]" : "text-[#0F1E19]"}`}>
        Verma Med
      </p>
      <p className={`font-mono text-[10px] uppercase tracking-[0.3em] ${dark ? "text-[#A3B8B0]" : "text-[#4A5D55]"}`}>
        Associates
      </p>
    </div>
  </div>
);
